import React, { useState } from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
    FaBusAlt,
    FaRoute,
    FaMapMarkedAlt,
    FaArrowRight,
    FaShieldAlt,
} from "react-icons/fa";

import { Link } from "react-router-dom";

const Transport = () => {

    const [open, setOpen] =
        useState(false);

    const transportRoutes = [

        {
            id: "vehicle-1-trip-1",
            title: "Vehicle No.1 Trip No.1",
            route: "Sinduriya",
            vehicle: "Vehicle 01",
            image:
                "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?q=80&w=1200&auto=format&fit=crop",
        },

        {
            id: "vehicle-1-trip-2",
            title: "Vehicle No.1 Trip No.2",
            route: "Babhanawli",
            vehicle: "Vehicle 01",
            image:
                "https://images.unsplash.com/photo-1494515843206-f3117d3f51b7?q=80&w=1200&auto=format&fit=crop",
        },

        {
            id: "vehicle-2-trip-1",
            title: "Vehicle No.2 Trip No.1",
            route: "Chowk",
            vehicle: "Vehicle 02",
            image:
                "https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1200&auto=format&fit=crop",
        },

        {
            id: "vehicle-2-trip-2",
            title: "Vehicle No.2 Trip No.2",
            route: "Kotwali Road",
            vehicle: "Vehicle 02",
            image:
                "https://images.unsplash.com/photo-1519003722824-194d4455a60c?q=80&w=1200&auto=format&fit=crop",
        },

        {
            id: "vehicle-3-trip-1",
            title: "Vehicle No.3 Trip No.1",
            route: "Bagapar",
            vehicle: "Vehicle 03",
            image:
                "https://images.unsplash.com/photo-1486006920555-c77dcf18193c?q=80&w=1200&auto=format&fit=crop",
        },

        {
            id: "vehicle-3-trip-2",
            title: "Vehicle No.3 Trip No.2",
            route: "Baspar Road",
            vehicle: "Vehicle 03",
            image:
                "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?q=80&w=1200&auto=format&fit=crop",
        },

        {
            id: "vehicle-4-trip-2",
            title: "Vehicle No.4 Trip No.2",
            route: "Baikunthpur",
            vehicle: "Vehicle 04",
            image:
                "https://images.unsplash.com/photo-1471478331149-c72f17e33c73?q=80&w=1200&auto=format&fit=crop",
        },

        {
            id: "vehicle-4-trip-1",
            title: "Vehicle No.4 Trip No.1",
            route: "Pakari Range",
            vehicle: "Vehicle 04",
            image:
                "https://images.unsplash.com/photo-1570125909232-eb263c188f7e?q=80&w=1200&auto=format&fit=crop",
        },

        {
            id: "vehicle-5-trip-1",
            title: "Vehicle No.5 Trip No.1",
            route: "Puraina Khandi",
            vehicle: "Vehicle 05",
            image:
                "https://images.unsplash.com/photo-1502877338535-766e1452684a?q=80&w=1200&auto=format&fit=crop",
        },

    ];

    return (

        <>
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            {/* PAGE */}
            <section className="w-full bg-[#f7f9fc] overflow-x-hidden">

                {/* HERO SECTION */}
                <div className="bg-gradient-to-r from-[#072F5F] to-[#0B4F9C] py-16 md:py-24 relative overflow-hidden">

                    <div className="absolute top-0 left-0 w-full h-full opacity-10">

                        <div className="absolute w-72 h-72 bg-white rounded-full -top-20 -left-20"></div>

                        <div className="absolute w-96 h-96 bg-[#D4A017] rounded-full -bottom-40 -right-20"></div>

                    </div>

                    <div className="max-w-7xl mx-auto px-5 md:px-10 text-center relative z-10">

                        <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-semibold">

                            School Facilities

                        </span>

                        <h1 className="text-4xl md:text-7xl font-extrabold text-white mt-5 leading-tight">

                            Transport Facility

                        </h1>

                        <p className="text-gray-200 text-base md:text-lg mt-6 max-w-3xl mx-auto leading-8">

                            Safe, secure and comfortable transportation
                            services covering multiple routes for students
                            across nearby towns and villages.

                        </p>

                    </div>

                </div>

                {/* MAIN CONTENT */}
                <div className="max-w-7xl mx-auto px-5 md:px-10 py-16">

                    {/* TOP INFO CARDS */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-16">

                        {/* CARD */}
                        <div className="bg-white rounded-3xl border border-gray-100 shadow-lg p-7 hover:-translate-y-2 transition-all duration-300">

                            <div className="w-16 h-16 rounded-2xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mb-5">

                                <FaBusAlt />

                            </div>

                            <h3 className="text-2xl font-bold text-[#072F5F]">

                                School Buses

                            </h3>

                            <div className="w-14 h-[3px] bg-[#D4A017] rounded-full my-4"></div>

                            <p className="text-gray-600 leading-7">

                                Well-maintained transport vehicles with
                                proper student safety.

                            </p>

                        </div>

                        {/* CARD */}
                        <div className="bg-white rounded-3xl border border-gray-100 shadow-lg p-7 hover:-translate-y-2 transition-all duration-300">

                            <div className="w-16 h-16 rounded-2xl bg-[#D4A017]/10 text-[#D4A017] flex items-center justify-center text-3xl mb-5">

                                <FaRoute />

                            </div>

                            <h3 className="text-2xl font-bold text-[#072F5F]">

                                Route Coverage

                            </h3>

                            <div className="w-14 h-[3px] bg-[#D4A017] rounded-full my-4"></div>

                            <p className="text-gray-600 leading-7">

                                Multiple transport routes for nearby areas
                                and villages.

                            </p>

                        </div>

                        {/* CARD */}
                        <div className="bg-white rounded-3xl border border-gray-100 shadow-lg p-7 hover:-translate-y-2 transition-all duration-300">

                            <div className="w-16 h-16 rounded-2xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mb-5">

                                <FaShieldAlt />

                            </div>

                            <h3 className="text-2xl font-bold text-[#072F5F]">

                                Student Safety

                            </h3>

                            <div className="w-14 h-[3px] bg-[#D4A017] rounded-full my-4"></div>

                            <p className="text-gray-600 leading-7">

                                Experienced drivers and secure transportation
                                management.

                            </p>

                        </div>

                        {/* CARD */}
                        <div className="bg-white rounded-3xl border border-gray-100 shadow-lg p-7 hover:-translate-y-2 transition-all duration-300">

                            <div className="w-16 h-16 rounded-2xl bg-[#D4A017]/10 text-[#D4A017] flex items-center justify-center text-3xl mb-5">

                                <FaMapMarkedAlt />

                            </div>

                            <h3 className="text-2xl font-bold text-[#072F5F]">

                                Daily Trips

                            </h3>

                            <div className="w-14 h-[3px] bg-[#D4A017] rounded-full my-4"></div>

                            <p className="text-gray-600 leading-7">

                                Morning and evening trips for convenient
                                student travel.

                            </p>

                        </div>

                    </div>

                    {/* VEHICLE CARDS */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">

                        {
                            transportRoutes.map(
                                (
                                    item,
                                    index
                                ) => (

                                    <Link
                                        to={`/transport/${item.id}`}
                                        key={index}
                                        className="
                                            group
                                            bg-white
                                            rounded-[30px]
                                            overflow-hidden
                                            shadow-xl
                                            border
                                            border-gray-100
                                            hover:-translate-y-3
                                            hover:shadow-2xl
                                            transition-all
                                            duration-500
                                            block
                                        "
                                    >

                                        {/* IMAGE */}
                                        <div className="relative h-[280px] overflow-hidden">

                                            <img
                                                src={item.image}
                                                alt={item.route}
                                                className="
                                                    w-full
                                                    h-full
                                                    object-cover
                                                    group-hover:scale-110
                                                    transition-all
                                                    duration-700
                                                "
                                            />


                                            {/* ROUTE */}
                                            <div className="absolute bottom-6 left-6">

                                                <h3 className="text-white text-3xl font-bold">

                                                    {item.route}

                                                </h3>

                                            </div>

                                        </div>

                                        {/* CONTENT */}
                                        <div className="p-7">

                                            <h2 className="text-[#072F5F] text-2xl font-extrabold leading-9">

                                                {item.title}

                                            </h2>

                                            <div className="w-16 h-[3px] bg-[#D4A017] rounded-full my-5"></div>

                                            {/* BUTTON */}
                                            <div className="mt-7 flex items-center justify-between">

                                                <span className="text-[#0B4F9C] text-lg font-bold">

                                                    View Details

                                                </span>

                                                <div className="w-12 h-12 rounded-full bg-[#0B4F9C] text-white flex items-center justify-center group-hover:bg-[#D4A017] group-hover:rotate-45 transition-all duration-300">

                                                    <FaArrowRight />

                                                </div>

                                            </div>

                                        </div>

                                    </Link>
                                )
                            )
                        }

                    </div>

                </div>

            </section>

            <Footer />
        </>
    );
};

export default Transport;